import { Route } from 'react-router-dom';
import SchedulePage from './components/Schedule.page';
import AppointmentsPage from './components/Appointments.page';
import CarePlanPage from '../../components/pageComponents/CarePlan.page';
import EditProfilePage from '../../components/pageComponents/EditProfile.page';

export const getCareConnectRoutes = ({ isMinimized }) => {
  const pages = [
    {
      path: '/schedule/:id',
      Component: SchedulePage,
    },
    {
      path: '/appointments',
      Component: AppointmentsPage,
    },
    {
      path: '/careplan',
      Component: CarePlanPage,
    },
    {
      path: '/editprofile',
      Component: EditProfilePage,
    },
  ];

  return pages.map((route) => {
    const { path, Component } = route;
    return (
      <Route
        key={path}
        path={path}
        element={<Component isMinimized={isMinimized} />}
      />
    );
  });
};
